export const depositPaymentSwitching = {
  depositPaymentSwitching: 'Deposit Transaction',
  username: 'Username',
  paymentName: 'PaymentName',
  refCode1: 'Ref Code 1',
  status: 'Status',
  transactionId: 'Transaction ID',
  refCode3: 'Ref Code 3',
  createdAt: 'Created At',
  advanceFilter: 'Advance Filter',
  searchUsername: 'Search username',
  amount: 'Amount',
  message: 'Message',
  searchBankAccountNumber: 'search by bank account number',

}
